import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsApp = () => {
  return (
    <>
      <style>
        {`
          @keyframes pop {
            0% {
              transform: scale(0);
              opacity: 0;
            }
            70% {
              transform: scale(1.2);
              opacity: 1;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
          .animate-pop {
            animation: pop 0.5s ease-out forwards;
          }
        `}
      </style>
      <a
        href="https://wa.me/94770483364"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-4 sm:bottom-36 sm:right-6 bg-[#25D366] text-white p-2 sm:p-3 md:p-4 rounded-full shadow-lg hover:bg-[#20b354] transition-colors duration-300 z-50 animate-pop"
        aria-label="Contact us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10" />
      </a>
    </>
  );
};

export default WhatsApp;